module.exports = __webpack_public_path__ + "static/media/selected.3acddf5b.svg";